import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/components/home')
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import('@/components/contactUs')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js